








































































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// Component
import { DropifyFile, Select2 } from '@/components/form'
import TableListAssistancesDevice from './TableListAssistancesDevice.vue'
import FormGetFromDevice from './FormGetFromDevice.vue'

// Models
import { AssistanceDevice } from '@/models/assistance'
import { ImageForm, PropOptionSelect } from '@/models'
import { DeviceModel } from '@/models/config'

// utils
import { loading, alerts } from '@/utils'

// constants
import { TYPE_MARKING_ENTRY, TYPE_MARKING_EXIT } from '@/constants'

// Services
import { AssistanceService } from '@/services/assistance'
import { DeviceService } from '@/services/config'

@Component({
    name: 'FormImportAssistance',
    components: {
        DropifyFile,
        TableListAssistancesDevice,
        Select2,
        FormGetFromDevice
    }
})
export default class FormImportAssistance extends Vue {
    @Prop({ type: String, required: true }) typeImport!: string

    file: ImageForm|null = null
    assistances: AssistanceDevice[] = []
    assistancesValid: AssistanceDevice[] = []
    deviceId: number|null = null
    devices: DeviceModel[] = []
    disableDeviceSelect = false

    get devicesOp (): PropOptionSelect[] {
        return this.devices.map(d => {
            return {
                value: d.id,
                text: d.name
            }
        })
    }

    async created () {
        this.devices = await DeviceService.getAllActivedAndConnected()
    }

    inAssistances (assistance: AssistanceDevice) {
       return this.assistances.find(a => a.date === assistance.date && a.employee_id === assistance.employee_id) ?? false
    }

    setLastLikeExit (date: string, employee_id: number) {
        const assistances = this.assistances.filter(a => a.date === date && a.employee_id === employee_id && a.type !== TYPE_MARKING_ENTRY)
        const total = assistances.length
        if (total > 0) {
            assistances.forEach(a => {
                if (!a.isRegistered) {
                    a.type = 0
                }
            })
            const last = assistances[total - 1]
            if (!last.isRegistered) {
                last.type = TYPE_MARKING_EXIT
            }
        }
    }

    setUidAssistance (uid: number) {
        const exist = this.assistances.find(a => a.uid === String(uid))
        if (!exist) {
            return String(uid)
        } else {
            const num = Math.floor(Math.random() * (10000 - 1) + 1)
            return String(num)
        }
    }

    setAssists (info: { assists: AssistanceDevice[]; deviceId: number }) {
        this.deviceId = info.deviceId
        info.assists.forEach((a) => {
            if (!this.inAssistances(a) && a.employee?.id) {
                if (!a.isRegistered) {
                    a.type = TYPE_MARKING_ENTRY
                }
                this.assistances.push(a)
            } else {
                this.assistances.push(a)
                this.setLastLikeExit(a.date, a.employee?.id || 0)
            }
        })
        this.disableDeviceSelect = true
    }

    async save () {
        loading('show')
        if (this.file) {
            const result = await AssistanceService.importFile({
                file: this.file
            })
            if (result.success) {
                alerts.success('Actualizado con Éxito.!')
                this.$emit('save-success')
            } else {
                alerts.error()
            }
        } else {
            alerts.error('Debe seleccionar un Archivo')
        }
        loading('hide')
    }

    handleChangeFile (file: ImageForm) {
        this.file = file
    }
}
